import { ButtonLink, Flex } from '@applyboard/crystal-ui';
import { PlusOutlineIcon } from '@applyboard/ui-icons';

import { PageHeader } from '~/components/PageHeader';
import { SelectedIntakesBar } from '../components';
import {
  QueryFilter,
  Sort,
  CampusFilter,
  IntakeFilter,
  StatusFilter,
  IntakesFilterSummary,
  IntakesPagination,
  IntakesTable,
} from '~/components/Intake';

export function DesktopLayout() {
  return (
    <Flex p={10} gap={8} direction="column">
      <Flex justify="between" align="center">
        <PageHeader title="Intake Management" />
        <ButtonLink href="/intake-management/new" intent="primary" leadIcon={PlusOutlineIcon}>
          Add Intake
        </ButtonLink>
      </Flex>
      <Flex gap={2}>
        <Filter as={<QueryFilter />} width="100%" />
        <Filter as={<CampusFilter />} width="auto" />
        <Filter as={<IntakeFilter />} width="auto" />
        <Filter as={<StatusFilter />} width="auto" />
        <Filter as={<Sort />} width="auto" />
      </Flex>
      <Flex pt={2}>
        <IntakesFilterSummary />
      </Flex>
      <SelectedIntakesBar />
      <IntakesTable />
      <IntakesPagination />
    </Flex>
  );
}

function Filter(props: { as: React.ReactNode; width: string }) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
